module.exports = "/images/Icon industry-Bowling.svg?56de98707de114282bf85118e376f55b";